var exports = {
  "iE": "xcc377c0b--2bd882--wrapper",
  "Kk": "xcc377c0b--2bd882--icon",
  "DD": "xcc377c0b--2bd882--title",
  "iU": "xcc377c0b--2bd882--message",
};

module.exports = exports;
